<template>
    <div style="height: 100%; width: 100%;">
        <div class="custom-container">
            <v-row no-gutters justify="center">
                <v-col cols="12" md="8">
                    <v-card flat>
                        <v-card-title class="headline">
                            Mitarbeitergespräch Ansicht
                        </v-card-title>
                    </v-card>
                    <AppUtilityUserCard v-if="interviewed.id" :readonly="true" :payload="interviewed"/>
                    <v-card flat class="mt-1">
                        <EmployeeInterviewsUtilityForm v-on:getUser="interviewed = $event"/>
                    </v-card>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
    export default {
        props: [],
        name: "employee-interviews-edit-content",
        data: () => ({
            interview: '',
            interviewed: {},
        }),
        computed: {
        },
        mounted() {
        },
        methods: {
        }

    }
</script>

<style scoped>

</style>